import React, { useState, useEffect } from "react";
import { getLanguage } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import "./TopBanner.css";
import bannerImg from "./assets/home_icons/banner.png";
import appointmentIcon from "./assets/Garbh Samarthya/vectors-02.png";

const translationData = {
  en: en,
  mr: ma
};

const TopBanner = ({ lang }) => {
  const bgUrl = "https://res.cloudinary.com/dtuy184dc/image/upload/v1775224475/HomePage_HeroImage-33.jpg12_gi9j7e.jpg";
  const [showModal, setShowModal] = useState(false);

  // Use lang prop for language
  const language = lang || 'en';

  // Video URLs for English and Marathi
  const marathiVideo = "https://www.youtube.com/embed/WfU5jaxulH8?autoplay=1";
  const englishVideo = "https://www.youtube.com/embed/h0oNjdKIJzk?autoplay=1";
  const videoEmbedUrl = (language === "ma" || language === "mr") ? marathiVideo : englishVideo;

  // Helper function to get translation by key
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  return (
    <section className="top-banner" style={{ backgroundImage: `url(${bgUrl})` }}>
      <div className="top-banner-overlay">
        <div className="top-banner-inner container">
          <div className="banner-text">
            <div className="eyebrow !text-secondary">{t('banner_eyebrow')}</div>
            <h1 dangerouslySetInnerHTML={{ __html: t('banner_title') }} />
            <p className="lead">
              {language === 'mr' || language === 'ma' ? (
                <>
                  वैचारिक स्पष्टता, मनःशांती आणि समतोल जीवनासाठी, विज्ञान, आध्यात्म आणि व्यवहाराचा समन्वय करणारे
                  <br />
                  मनशक्ती हे संशोधन केंद्र आहे
                </>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: t('banner_lead') }} />
              )}
            </p>
            <p className="subtitle">{t('banner_subtitle')}</p>

            <div className="banner-buttons">
              <button
                className="btn btn-primary outline"
                onClick={() => setShowModal(true)}
                aria-label={t('banner_watchVideo')}
              >
                {t('banner_watchVideo')} ▷
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  const el = document.getElementById('upcoming-courses');
                  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
              >
                {t('banner_upcomingCourses')}
                <img src={appointmentIcon} alt={t('banner_upcomingCourses')} className="btn-icon" />
              </button>
            </div>

            <div className="banner-stats">
              <div className="stat"><div className="num">{t('banner_stat_300')}</div><div className="label">{t('banner_stat_books')}</div></div>
              <div className="stat"><div className="num">{t('banner_stat_50000')}</div><div className="label">{t('banner_stat_courses')}</div></div>
              <div className="stat"><div className="num">{t('banner_stat_100000000')}</div><div className="label">{t('banner_stat_lives')}</div></div>
              <div className="stat"><div className="num">{t('banner_stat_65')}</div><div className="label">{t('banner_stat_years')}</div></div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setShowModal(false)}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="video-modal"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: 960,
              background: '#000',
              borderRadius: 8,
              padding: 0,
              overflow: 'hidden',
            }}
          >
            <button
              onClick={() => setShowModal(false)}
              aria-label="Close video"
              style={{
                position: 'absolute',
                right: 12,
                top: 12,
                zIndex: 10000,
                background: 'transparent',
                color: '#fff',
                border: 'none',
                fontSize: 28,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
              <iframe
                src={videoEmbedUrl}
                title="Introduction Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TopBanner;
